export default __webpack_public_path__ + "static/media/logo-bamboo.91d27ccd.svg";